<h2 class="mb-4">Ma ligne</h2>
<div class="row pt-2 line-status-container">
  <div class="col-6">
    <div class="row">
      <div class="col-auto bold-label-text"><strong>État :</strong></div>
      <div class="col-auto label">{{ landLine.status }} <app-dot [className]="'line_dot_status'"></app-dot></div>
    </div>
  </div>
  <div class="col-6 mb-3 offer-container">
    <div class="row">
      <div class="col-auto bold-label-text"><strong>Forfait :</strong></div>
      <div class="col-auto label">{{ landLine.offerName }}</div>
    </div>
  </div>

</div>

@if (landLine.billingFinishDate || landLine.billingStartDate) {
  <div class="row pt-2 line-status-container">
    <div class="col-6 offer-container">
      @if (landLine.billingStartDate) {
        <div class="row">
          <div class="col-auto bold-label-text"><strong>Date de début de facturation :</strong></div>
          <div class="col-auto label">{{ formatDate(landLine.billingStartDate) }}</div>
        </div>
      }
    </div>
    <div class="col-6 dates-container">
      @if (landLine.billingFinishDate) {
        <div class="row">
          <div class="col-auto bold-label-text"><strong>Date de fin de facturation :</strong></div>
          <div class="col-auto label">{{ formatDate(landLine.billingFinishDate) }}</div>
        </div>
      }
    </div>
  </div>
}

@if (filteredOptions.length > 0) {
    <div [className]="'hr-'+environment.data.brand"></div>
}

@if (filteredOptions.length > 0) {
    <h2>Mes options</h2>
}
@if (filteredOptions.length > 0) {
    <div class="row pt-2 option-grid">
        @for (option of filteredOptions; track option) {
            <div class="col-12 mb-2">
                - {{option.label}}
            </div>
        }
    </div>
}

@if (displayDocumentsBloc) {
  <div [className]="'hr-'+environment.data.brand"></div>
}

@if (displayDocumentsBloc) {
  <h2>Mes documents</h2>
}
@if (getFile(environment.data.landlineSubscriptionPurchaseOrderFileTypeSlug) != null) {
  <div>
    <a (click)="downloadFile(getFile(environment.data.landlineSubscriptionPurchaseOrderFileTypeSlug).id, 'Bon de commande')" class="pointer-cursor">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span>Bon de commande
    </a>
  </div>
}
@if (getFile(environment.data.customerContractFileTypeSlug) != null) {
  <div>
    <a (click)="downloadFile(getFile(environment.data.customerContractFileTypeSlug).id, 'Contrat')" class="pointer-cursor">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span>Contrat
    </a>
  </div>
}
@if (getFile(environment.data.landlineSubscriptionKbisFileTypeSlug) != null) {
  <div>
    <a (click)="downloadFile(getFile(environment.data.landlineSubscriptionKbisFileTypeSlug).id, 'kbis')" class="pointer-cursor">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span>KBIS
    </a>
  </div>
}
@if (getFile(environment.data.voucherFileTypeSlug) != null) {
  <div>
    <a (click)="downloadFile(getFile(environment.data.voucherFileTypeSlug).id, 'Bon de retour')" class="pointer-cursor">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span>Bon de retour
    </a>
  </div>
}
